import PropTypes from "prop-types";
import React, { useEffect, useRef } from "react";

import { useLocation } from "@swa-ui/browser";
import i18n from "@swa-ui/locale";
import { classNames } from "@swa-ui/string";

import styles from "./SkipToContent.module.scss";

/**
 * SkipToContent provides a hidden link, visible only to a screen reader, that when selected will move focus to the
 * first focusable item in the main content, bypassing the global nav with all of its options.
 */

export const SkipToContent = (props) => {
  const { light } = props;
  const { pathname } = useLocation();
  const ref = useRef(null);

  useEffect(() => {
    ref.current?.focus();
  }, [pathname]);

  return (
    <>
      {focusFirstElementOnPathChange()}
      <a href="#content" {...getProps()}>
        {i18n("SkipToContent__TEXT")}
      </a>
    </>
  );

  function getProps() {
    return {
      className: classNames(styles.hiddenFromScreen, { [styles.lightForeground]: light }),
    };
  }

  function focusFirstElementOnPathChange() {
    return <div ref={ref} tabIndex={-1} />;
  }
};

SkipToContent.displayName = "SkipToContent";
SkipToContent.propTypes = {
  /** Indicates if the app is using a dark background header. This value is passed to the header links for styling. */
  light: PropTypes.bool,
};
